module.exports = __webpack_public_path__ + "img/RMap.98ea2538.png";